module.exports = __webpack_public_path__ + "static/media/checkMark.3df3bccf.png";